var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErodeLogoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 20,
    viewBox: "0 0 88 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_122_1666)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1.28963H13.4999V5.56894H5.0325V8.14711H12.1685V12.4529H5.0325V15.5095H13.4999V19.7624H0V1.28963Z",
    fill: "#FAF9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2422 1.28963H24.7626C29.6084 1.28963 31.8985 4.82476 31.8985 8.14711C31.8985 10.6988 30.7267 13.0907 28.3041 14.2339L32.2183 19.7624H26.3602L23.0054 14.9781H21.2747V19.7624H16.2422V1.28963ZM21.2747 10.6189H24.4434C25.8013 10.6189 26.9732 9.50262 26.9732 8.14711C26.9732 6.68521 25.8013 5.64886 24.4434 5.64886H21.2747V10.6194V10.6189Z",
    fill: "#FAF9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.6221 1.28963H62.9712C67.9507 1.28963 71.8914 4.18696 71.8914 10.5395C71.8914 15.9615 67.9507 19.7624 62.9712 19.7624H55.6221V1.28963ZM62.5184 14.9781C64.6754 14.9781 66.8053 13.5427 66.8053 10.5395C66.8053 7.53632 64.6754 6.07442 62.5184 6.07442H60.6546V14.9787H62.5184V14.9781Z",
    fill: "#FAF9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.5 1.28963H87.9999V5.56894H79.5325V8.14711H86.6684V12.4529H79.5325V15.5095H87.9999V19.7624H74.5V1.28963Z",
    fill: "#FAF9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.9896 10.2581C53.9896 14.8107 51.0238 18.6526 46.9359 20C46.9223 19.9795 46.9061 19.96 46.8877 19.9411C46.1152 19.1116 45.1018 17.4256 47.0565 15.4102C51.0524 11.2999 46.6367 11.126 44.4142 9.98056C41.6664 8.59372 45.0272 7.37862 46.2093 5.42096C47.3909 3.4633 45.3745 3.80029 45.3745 3.80029C45.3745 3.80029 47.4033 4.01739 43.3138 6.39466C39.2243 8.77194 39.5262 11.2043 40.6969 11.7649C42.0743 12.4264 44.1897 13.0583 40.3469 16.0237C39.2811 16.8505 38.5404 17.8414 38.0265 18.8022C35.2635 16.9666 33.4365 13.8311 33.4365 10.2581C33.4365 4.61252 38.0573 0 43.7131 0C49.3688 0 53.9896 4.61252 53.9896 10.2581Z",
    fill: "#A2BBBF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_122_1666"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 88,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErodeLogoWhite);
export default __webpack_public_path__ + "static/media/erode-logo-white.4364cfa3141e345df46134a606c75b21.svg";
export { ForwardRef as ReactComponent };